"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorOverrideSchema = void 0;
const zod_1 = require("zod");
exports.ColorOverrideSchema = zod_1.z.tuple([
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
]);
//# sourceMappingURL=ColorOverride.js.map